/** @format */

import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { UuidString } from "../userResources/userResourceFunctions";

export interface lessonProgress {
  resourceUUID: UuidString;
  lessonUUID: UuidString;
  progress: number;
}

export interface ProgressState {
  lessonsProgress: lessonProgress[];
  status: "idle" | "loading" | "failed";
}

const initialState: ProgressState = {
  lessonsProgress: [],
  status: "idle",
};

export const updateLessonProgress = createAsyncThunk(
  "progress/updateProgression",
  async (lessonsProgress: lessonProgress[]) => {
    window.localStorage.setItem(
      "lessonProgress",
      JSON.stringify(lessonsProgress),
    );
    return lessonsProgress;
  },
);

export const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    setLessonsProgress: (state, action: PayloadAction<lessonProgress[]>) => {
      state.lessonsProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateLessonProgress.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateLessonProgress.fulfilled, (state, action) => {
        state.status = "idle";
        state.lessonsProgress = action.payload;
      })
      .addCase(updateLessonProgress.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { setLessonsProgress } = progressSlice.actions;
export const selectLessonsProgress = () => (state: RootState) =>
  state.progress.lessonsProgress;

export default progressSlice.reducer;
